<template>
  <b-modal
    :ref="modalRef"
    :id="`dormantToLiveModal-${campaignId}`"
    title="Overwrite Dormant State"
    data-test="dormant-to-live-modal"
    ok-title="Confirm"
    @ok="setCampaignLive()"
    @shown="shown()"
    hide-backdrop
    centered
  >
    <template #modal-title>
      <p
        class="mb-0 font-weight-bold"
      >
        <span class="icon mr-2">
          <i
            class="fas fa-exclamation-triangle warning"
          />
        </span>
        Overwrite Dormant State
      </p>
    </template>
    <div class="d-block">
      <p>Changing this campaign's state will immediately set the start date of the upcoming campaign period to today's date. This action cannot be undone</p>
      <p>Are you sure you want to proceed?</p>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'DormantToLiveModal',
  props: {
    advertiserId: {
      type: Number,
      required: true,
    },
    campaignId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      orderId: 0,
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    modalRef() {
      return `dormantToLiveModal-${this.campaignId}`;
    },
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.SET_DORMANT_CAMPAIGN_LIVE,
      campaignTypes.FETCH_ORDER,
    ]),
    showModal() {
      this.$refs[this.modalRef].show();
    },
    setCampaignLive() {
      this.SET_DORMANT_CAMPAIGN_LIVE({ campaignId: this.orderId }).then(() => {
        this.$emit('updateState', this.campaignId);
      });
    },
    shown() {
      this.FETCH_ORDER({ advertiserId: this.advertiserId, campaignId: this.campaignId })
        .then((response) => {
          this.orderId = response.id;
        });
    },
  },
};
</script>
